import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import classNames from 'classnames';
import { AButton } from './abutton';

/**
 * GDPR component - Modified to auto-accept cookies
 *
 * NOTE: GDPR blocking functionality has been commented out per requirement
 * to avoid blocking site usage. This modification was requested to ensure
 * users can access the site without being forced to accept cookies.
 *
 * While this improves UX, it may not comply with strict GDPR requirements
 * in certain jurisdictions. Consult legal team before deploying to production.
 */
const Gdpr = ({ location }) => {
  const [show, setShow] = useState(false);
  // Restriction state is disabled
  /* const [isRestricted, setIsRestricted] = useState(false); */

  // List of EU countries (kept for reference)
  /* 
  const restricted = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GB', 'GR', 'HU', 'IE', 'IT', 'LV', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  ]; 
  const excludedPages = ['terms', 'privacy', 'sla', 'data-privacy'];
  */

  useEffect(() => {
    const storageFlag = localStorage.getItem('hideGdpr');

    if (!storageFlag || storageFlag === 'false') {
      setShow(true);

      // Original code kept but commented out for reference
      // checkCountryCode();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Country code checking function kept but commented out
  /* 
  const checkCountryCode = async () => {
    axios.get(`https://ipapi.co/json/`).then(result => {
      if (result) {
        const { data } = result;

        if (restricted.indexOf(data.country_code) !== -1) {
          restrictUser();
        } else if (data.country_code === 'US' && data.region_code === 'CA') {
          restrictUser();
        } else {
          setIsRestricted(false);
          document.body.style.overflow = 'unset';
        }
      }
    });
  }; 
  */

  // User restriction function kept but commented out
  /* 
  const restrictUser = () => {
    if (!excludedPages.includes(location.pathname.replace(/\//g, ''))) {
      setIsRestricted(true);
      document.body.style.overflow = 'hidden';
    }
  };
  */

  const onYes = () => {
    closeWindow();
  };

  const closeWindow = () => {
    localStorage.setItem('hideGdpr', true);
    document.body.style.overflow = 'unset';
    setShow(false);
  };

  // Show the banner but don't block the site
  return (
    show && (
      <div
        className={classNames(
          'fixed bottom-6 left-6 z-[1000]'
          // {
          //   '!inset-0 bg-black/70': isRestricted,
          // }
        )}
      >
        <div
          className={classNames(
            'w-[calc(100vw-56px)] rounded-lg border border-black/10 bg-white p-4 shadow sm:w-[264px]'
            // {
            //   'absolute bottom-6 left-6': isRestricted,
            // }
          )}
        >
          <div className="mb-2 text-sm font-semibold text-black">
            Do you agree to cookies?
          </div>
          <div className="mb-4 text-[13px] leading-[130%] text-black/80">
            By using our website you understand that we and our affiliates may
            use cookies. For more information, please visit our{' '}
            <a
              className="text-azure-800"
              href="/privacy"
              target="_blank"
              rel="noreferrer"
            >
              privacy policy
            </a>
            .
          </div>
          <AButton
            type="primary"
            size="sm"
            onClick={() => {
              onYes();
            }}
            hideIcon
          >
            Accept all
          </AButton>
        </div>
      </div>
    )
  );
};

export default Gdpr;
